
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.034 3.33a.607.607 0 00-.607.608v12.75c0 .335.272.607.607.607H18.82a.607.607 0 00.607-.607V3.938a.607.607 0 00-.607-.607H3.034zm.607 3.45v9.3h14.572v-9.3l-6.111 5.158a1.82 1.82 0 01-2.35 0L3.642 6.78zm14.572-1.588v-.647H3.64v.647l6.894 5.818a.607.607 0 00.783 0l6.894-5.818z","fill":"currentColor"}})])
          )
        }
      }
    